<div class="listContainer" id="powerSearchTemplate" *ngIf="powersearchvisible">

  <!-- Back -->
  <div class="back backLink">
    <a href="#" (click)="$event.preventDefault(); GoBack()" class="tg-back-btn">
      <i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i>
      <span class="UnderLineLink">{{'Link_Back' | translate}}</span>
    </a>
  </div>

  <ul class="jobList">

    <!-- Keyword -->
    <li *ngIf="hidekeyword === false">
      <div class="fieldcontain liner">

        <label id="keywordLabel" for="ps-keyword-input" class="powerSearchLabel">{{'Label_Keyword'| translate }}</label>

        <p>
          <app-primeng-autocomplete-single-select
            [model]="keyWordSearch"
            
            [placeholder]="'Label_SearchByJobTitle' | translate"
            searchType="powerSearchKeyWordSearch">
          </app-primeng-autocomplete-single-select>
        </p>

      </div>
    </li>

    <!-- Location -->
    <li *ngIf="hidelocation === false">
      <div class="fieldcontain liner">

        <label id="locationLabel" for="ps-location-input" class="powerSearchLabel">{{'Label_Location'| translate }}</label>

        <p>
          <app-primeng-autocomplete-single-select
            [model]="locationSearch"
           
            [placeholder]="'Label_SearchByLocation' | translate"
            searchType="powerSearchLocationSearch">
          </app-primeng-autocomplete-single-select>
        </p>

      </div>
    </li>

    <!-- Dynamic Questions -->
    <li *ngFor="let q of questions">
      <div class="fieldcontain liner">

        <!-- TEXT / EMAIL -->
        <ng-container *ngIf="q.QuestionType==='text'|| q.QuestionType==='email'">
          <label class="powerSearchLabel" [for]="'text_' + q.QId" [innerHTML]="q.QuestionDescription | safeHtml"></label>
          <input type="text"
            class="control"
           [name]="'PowerSearch_' + q.QuestionDescription"
            [(ngModel)]="q.Value"
            [id]="'text_' + q.QId"
          />
        </ng-container>

        <!-- NUMERIC -->
        <ng-container *ngIf="q.QuestionType==='numeric'">
          <label class="powerSearchLabel" [for]="'text_' + q.QId" [innerHTML]="q.QuestionDescription | safeHtml"></label>
          <input  type="text"
            [name]="'PowerSearch_' + q.QuestionDescription"
            class="control"
            [(ngModel)]="q.Value"
            [id]="'text_' + q.QId"
            pattern="^[0-9]*$"
          />
        </ng-container>

        <!-- TEXTAREA -->
        <ng-container *ngIf="q.QuestionType === 'textarea'">
          <label class="powerSearchLabel" [id]="'q_txt_lbl_' + q.QId" [for]="'textarea_' + q.QId" [innerHTML]="q.QuestionDescription | safeHtml"></label>
          <textarea
            [name]="'PowerSearch_' + q.QuestionDescription"
            maxlength="400"
            cols="40"
            rows="5"
            [(ngModel)]="q.Value"
            [id]="'textarea_' + q.QId"
            [attr.aria-labelledby]="'q_txt_lbl_' + q.QId">
          </textarea>
        </ng-container>

        <!-- SELECT / MULTI / CHECKBOX -->
        <ng-container *ngIf="q.QuestionType === 'select' ||
                         q.QuestionType === 'multi-select' ||
                         q.QuestionType === 'single-select' ||
                         q.QuestionType === 'radio' ||
                         q.QuestionType === 'checkbox'">

          
            <label class="powerSearchLabel" [id]="'label_' + q.QId" [for]="'text_' + q.QId" *ngIf="q.IsAutoComplete" [innerHTML]="q.QuestionDescription | safeHtml"></label>
<label class="powerSearchLabel" [id]="'label_' + q.QId"  *ngIf="!q.IsAutoComplete" [innerHTML]="q.QuestionDescription | safeHtml"></label>

            <!-- Autocomplete -->
            <app-primeng-auto-complete
              [question]="q"
              
              (selectedChange)="onMultiSelectChange(q, $event)"
              *ngIf="q.Options.length === 0 || q.IsAutoComplete">
            </app-primeng-auto-complete>

            <!-- Checkbox list — fieldset/legend ensures group name is announced by JAWS/NVDA -->
            <fieldset class="powersearch-checkbox-group"
                 *ngIf="q.Options.length > 0 && !q.IsAutoComplete">
              <legend class="sr-only" [innerHTML]="q.QuestionDescription | safeHtml"></legend>

              <div class="checkboxWrapper"
                   *ngFor="let op of q.Options; let i = index">

                <input
                  type="checkbox"
                  appStyledInput
                  [(ngModel)]="op.Selected"
                  [id]="'q_' + q.QId + '_chk_' + i"
                />

                <label
                  class="checkboxLabel"
                  [for]="'q_' + q.QId + '_chk_' + i">
                  {{ op.OptionName | decodeHtml }}
                </label>

              </div>
            </fieldset>

         
        </ng-container>

        <!-- DATE -->
        <ng-container *ngIf="q.QuestionType === 'date'">
          <label [id]="'date_lbl_' + q.QId"
               [for]="q.QId == -1 ? 'date_' + q.QId : 'date_range_' + q.QId"
               class="powerSearchLabel" [innerHTML]="q.QuestionDescription | safeHtml">
          </label>
          <!-- WCAG 3.3.2: format instructions — IDs match what primeng-date-input sets on aria-describedby -->
          <span *ngIf="q.QId == -1" [id]="'date_' + q.QId + '_desc'" class="sr-only">Enter a date in MM/DD/YYYY format</span>
          <span *ngIf="q.QId != -1" [id]="'date_range_' + q.QId + '_desc'" class="sr-only">Enter a date range. Use MM/DD/YYYY format for each date</span>
          <p *ngIf="q.QId == -1"><span>{{'Label_IncludePostingsFrom' | translate}}</span></p>
          <p>
            <app-primeng-date-input *ngIf="q.QId == -1"
              [control]="q.dateCtrl"
              inputId="date_{{q.QId}}"
              [ariaLabelledBy]="'date_lbl_' + q.QId"
              selectionMode="single"
              view="date"
              (dateStringChange)="onDateChange(q, $event)">
            </app-primeng-date-input>
          </p>

          <p *ngIf="q.QId != -1">
            <app-primeng-date-input
              [control]="q.dateCtrl"
              inputId="date_range_{{q.QId}}"
              [ariaLabelledBy]="'date_lbl_' + q.QId"
              selectionMode="range"
              view="date"
              (dateStringChange)="onDateChange(q, $event)">
            </app-primeng-date-input>
          </p>
        </ng-container>
      </div>
    </li>

  </ul>

  <!-- Actions -->
  <div class="bottomControlWrapper">

    <button class="primaryButton ladda-button"
            (click)="powerSearchJobs()">
      <span class="ladda-label">{{ this.SearchButtonText }}</span>
    </button>

    <a class="UnderLineLink bottomControl"
       (click)="cancel()"
       role="button"
       tabindex="0"
       (keydown.enter)="cancel()"
       (keydown.space)="$event.preventDefault(); cancel()">
      {{ 'Button_Cancel' | translate }}
    </a>

  </div>

</div>